export default "__VITE_ASSET__CiuYcED0__"